<template>
  <SommaireView
    v-if="page === 'sommaire'"
    :recueils="RECUEILS"
    @go-about="navigate('about')"
    @go-recueil="goRecueil"
    @go-texte="goTexte"
  />
  <RecueilView
    v-else-if="page === 'recueil'"
    :recueil="currentRecueil"
    @go-sommaire="navigate('sommaire')"
    @go-texte="goTexteFromRecueil"
  />
  <TexteView
    v-else-if="page === 'texte'"
    :recueil="currentRecueil"
    :texte="currentTexte"
    :texte-index="texteIndex"
    @go-sommaire="navigate('sommaire')"
    @go-recueil="navigate('recueil')"
    @go-next="goNext"
    @go-texte="goTexteInSidebar"
  />
  <AboutView
    v-else-if="page === 'about'"
    @go-sommaire="navigate('sommaire')"
  />
</template>

<script setup lang="ts">
import { ref, computed, onMounted, onBeforeUnmount } from 'vue'
import type { PageName } from './types'
import { RECUEILS } from './data/recueils'
import SommaireView from './views/SommaireView.vue'
import RecueilView from './views/RecueilView.vue'
import TexteView from './views/TexteView.vue'
import AboutView from './views/AboutView.vue'

const page = ref<PageName>('sommaire')
const recueilIndex = ref(0)
const texteIndex = ref(0)

const currentRecueil = computed(() => RECUEILS[recueilIndex.value])
const currentTexte = computed(() => currentRecueil.value.texts[texteIndex.value])

function navigate(p: PageName, ri = recueilIndex.value, ti = texteIndex.value) {
  recueilIndex.value = ri
  texteIndex.value = ti
  page.value = p
  history.pushState({ page: p, ri, ti }, '')
}

function goRecueil(ri: number) {
  navigate('recueil', ri)
}

function goTexte(ri: number, ti: number) {
  navigate('texte', ri, ti)
}

function goTexteFromRecueil(ti: number) {
  navigate('texte', recueilIndex.value, ti)
}

function goTexteInSidebar(ti: number) {
  texteIndex.value = ti
  history.pushState({ page: 'texte', ri: recueilIndex.value, ti }, '')
}

function goNext() {
  const total = currentRecueil.value.texts.length
  const ti = (texteIndex.value + 1) % total
  texteIndex.value = ti
  history.pushState({ page: 'texte', ri: recueilIndex.value, ti }, '')
}

function onPopState(e: PopStateEvent) {
  const s = e.state
  if (s) {
    recueilIndex.value = s.ri
    texteIndex.value = s.ti
    page.value = s.page
  } else {
    page.value = 'sommaire'
  }
}

onMounted(() => {
  history.replaceState({ page: 'sommaire', ri: 0, ti: 0 }, '')
  window.addEventListener('popstate', onPopState)
})

onBeforeUnmount(() => {
  window.removeEventListener('popstate', onPopState)
})
</script>
